<template>
  <section class="section">
    <div class="content">
      <h1 class="subtitle">
        Hebrew Transliteration &amp; Gematria
      </h1>

      <p>
        <back-button />
      </p>
    </div>

    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label">Transliteration to Latin Characters</label>
          <div class="control">
            <input class="input" v-model="transliteration">
          </div>
        </div>

        <div class="field">
          <label class="label">Hebrew Characters</label>
          <div class="control">
            <input class="input" readonly v-model="hebrew">
          </div>
        </div>

        <div class="field">
          <label class="label">Gematria Value</label>
          <div class="control">
            <input class="input" readonly v-model="gematria">
          </div>
        </div>
      </div>

      <div class="column is-8">
        <div class="keyboard buttons has-addons is-centered">
          <button v-for="letter in letters" :key="letter.abbr" class="button" @click="append(letter)">
            <strong>{{ letter.hebrew }}</strong>
            {{ letter.name }}
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gematriaEquation, transliterationToHebrew, hebrewLetters } from '@/hebrew'
import BackButton from '@/components/pages/BackButton'

export default {
  components: {
    BackButton
  },
  computed: {
    hebrew () {
      return transliterationToHebrew(this.transliteration)
    },
    gematria () {
      return gematriaEquation(this.hebrew)
    }
  },
  data () {
    return {
      transliteration: '',
      letters: hebrewLetters
    }
  },
  methods: {
    append (letter) {
      this.transliteration += letter.abbr
    }
  }
}
</script>

<style lang="sass" scoped>
.textarea
  min-height: 5em
  max-height: 5em

.keyboard
  .button
    strong
      margin-right: 0.75rem

@media (min-width: 768px)
  .keyboard
    .button
      height: 3em

      strong
        font-size: 1.5em

@media (min-width: 1024px)
  .keyboard
    .button
      height: 4em

      strong
        font-size: 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/HebrewTransliterationPage.vue